import dateUtils from '../../../_helpers/dateUtils'

const Date = (path) => (rowData) =>
  rowData[path] ? dateUtils.formatDate(rowData[path]) : ''

export default Date
